export default function EmptyStateComponent({ title }) {
  return (
    <div className="text-center p-5">
      <i
        className="mdi mdi-emoticon-sad-outline"
        style={{ fontSize: "5rem", color: "#ccc" }}
      />
      <h4 className="text-muted">{title}</h4>
    </div>
  );
}
